import React, { useEffect, useState } from 'react'
import { useChangeServiceCategoryStatusMutation, useCreateServiceCategoryMutation, useDeleteServiceCategoryCatMutation, useDeleteServiceCategoryMutation, useServicesQuery, useSingleServiceCategoryQuery, useUpdateServiceCategoryMutation } from '../../../Store/Apis/servicesApi'
import Loader from '../../../Components/Loader/Loader'
import Error from '../../../Components/Error/Error'
import { Table } from 'antd'
import { SearchOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom'
import { Modal } from 'react-bootstrap'
import toast from 'react-hot-toast'
import AddEditServiceCategory from '../../../Components/AddEditServiceCategory/AddEditServiceCategory'
import { useSelector } from 'react-redux'


const Category = () => {
  const user = useSelector((state) => state.auth.user);
  const [sortFilter, setSortFilter] = useState({
    search: ''
  });
  
  const categoryApi = useServicesQuery({
    keyword: sortFilter.search,
    keyID: sortFilter.keyID
  })

  // ADD SERVICE PRODUCT
  const [createServiceCategory, createServiceCategoryResponse] = useCreateServiceCategoryMutation();
  const [addServiceCategoryModalShow, setAddServiceCategoryModalShow] = useState(false);

  const AddServiceCategory = () => {
    const handleAdd = (formData) => {
      console.log('Add Service Category Submitted:', formData);
      const serviceCategoryBody = {
        serviceCategoryName: formData.name,
        image: formData.logo,
        isActive: 1
      };
      createServiceCategory(serviceCategoryBody).then((res) => {
          console.log(res);
          if (res?.data?.status === 200) {
            setAddServiceCategoryModalShow(false);
            toast.success(res?.data?.message, { duration: 7000 });
          } else {
            toast.error(res?.data?.message, { duration: 7000 });
          }
      }).catch((err) => {
          toast.error("An error occurred. Please try again.", { duration: 7000 });
      });
    };

    return (
      <Modal show={addServiceCategoryModalShow} onHide={() => setAddServiceCategoryModalShow(false)} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Service Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <AddEditBrand onSubmit={handleAdd} /> */}
          <AddEditServiceCategory onSubmit={handleAdd}/>
        </Modal.Body>
      </Modal>
    );
  };


  // EDIT SERVICE PRODUCT
  const [updateServiceCategory, updateServiceCategoryResponse] = useUpdateServiceCategoryMutation();
  const [updateServiceCategoryId, setServiceCategoryId] = useState(null);
  const [updateServiceCategoryModalShow, setServiceCategoryModalShow] = useState(false);
  const singleServiceCategory = useSingleServiceCategoryQuery(
    {
      keyID: updateServiceCategoryId
    },
    {skip: !updateServiceCategoryId}
  )

  const UpdateServiceCategory = () => {
    console.log(singleServiceCategory)
    const handleUpdate = (formData) => {
      console.log('Update Service Category Submitted:', formData);
      const updateBody = {
        id: updateServiceCategoryId,
        serviceCategoryName: formData.name,
        image: formData.logo,
        isActive: 1
      };

      updateServiceCategory(updateBody).then((res) => {
          console.log(updateServiceCategoryResponse);
          if (res?.data?.status === 200) {
            setServiceCategoryModalShow(false);
            toast.success(res?.data?.message, { duration: 7000 });
          } else {
            toast.error(res?.data?.message, { duration: 7000 });
          }
      }).catch((err) => {
          toast.error("An error occurred. Please try again.", { duration: 7000 });
      });
    };

    return (
      <Modal show={updateServiceCategoryModalShow} onHide={() => setServiceCategoryModalShow(false)} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title>Update Service Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <AddEditServiceCategory
              onSubmit={handleUpdate}
              data={{
                name: singleServiceCategory?.data?.data[0].name,
                logo: singleServiceCategory?.data?.data[0].logo
              }}
            />
        </Modal.Body>
      </Modal>
    );
  };


  // STAUS CHANGE
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [changeStatus] = useChangeServiceCategoryStatusMutation()
  const handleChangeStatus = () => {
      changeStatus(selectedStatus).then((res)=>{
        console.log(res)
        setSelectedStatus(null)
      })
  }

  // DELETE
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [deleteCategory] = useDeleteServiceCategoryCatMutation()
  const handleDelete = () => {
    console.log(selectedRecord)
      deleteCategory(selectedRecord).then((res)=>{
        console.log(res)
        setSelectedRecord(null)
      })
  }

  const columns = [
    {
      title: 'Service Category',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name),
      filter: (value, record) => record.name.toLowerCase().includes(value.toLowerCase()),
      filterIcon: <SearchOutlined />,
      onFilter: (value, record) => record.name.toLowerCase().includes(value.toLowerCase()),
      render: (i, action) => (
        <>
          <p className='mb-1 text-sm'>{action.name}</p>
        </>
      )
    },
    {
      title: 'Category Image',
      dataIndex: 'logo',
      key: 'logo',
      render: (i, action) => (
        <>
          <img src={action.logo} alt="" height={50} />
        </>
      )
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (i, action) => (
        <button 
          type='button' 
          className={`btn badge badge-xs ${action.isActive == 1 ? 'badge-success': 'badge-danger'} fw-600 text-xs mb-0`} 
          onClick={() => setSelectedStatus({
              keyID: action.id,
              isActive: action.isActive == 1 ? 0 : 1
          })}
        >
            {action.isActive == 1 ? 'Active': 'Deactivated'}
        </button>
      )
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      key: 'actions',
      render: (i, action) => (
        <>
          <button type='button' className="btn ms-2 badge badge-xs badge-warning text-xs fw-600 mb-0" onClick={() => (setServiceCategoryId(action.id), setServiceCategoryModalShow(true))}>
            View & Edit
          </button>
          <button 
            type='button'
            className="btn ms-2 badge badge-xs badge-danger text-xs fw-600 mb-0"
            onClick={()=>setSelectedRecord(action.id)}
          >
            Delete
          </button>
        </>
      ),
    }
  ]


  return (
    <div>
      <div className="row align-items-center justify-content-between mb-4">
        <div className="col">
          <h5 className="fw-500 text-white">Service Category</h5>
        </div>
        <div className="col-auto">
          <button type='button' onClick={()=>setAddServiceCategoryModalShow(true)} className="btn btn-icon btn-3 btn-white text-primary mb-0">
            <i className="fa fa-plus me-2"></i> Add New Category
          </button>
        </div>
      </div>
      <div>
        <div className="row">
          <div className="col-12">
            <div className="card mb-4">
              <div className="card-header p-4">
                <div className="row gx-3">
                  <div className="col-md-12">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by Service Category"
                      value={sortFilter?.search || ""}
                      onChange={(e) => setSortFilter({...sortFilter, search: e.target.value})}
                    />
                  </div>
                </div>
              </div>
              <div className="card-body p-0">
                {categoryApi.isError && <Error/>}
                {categoryApi.isLoading && <Loader height="500px"/>}
                {
                  categoryApi.isSuccess && (
                    <Table 
                      columns={columns} 
                      dataSource={categoryApi?.data?.data}
                    />
                  )
                }
                <AddServiceCategory/>
                <UpdateServiceCategory/>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* STATUS CHANGE MODAL */}
      <Modal 
          show={selectedStatus} 
          onHide={() => setSelectedStatus(null)} 
          size="sm" 
          centered
      >
          <Modal.Body className='text-center p-4'>
              <h5>Are you sure you want to change status?</h5>
              <div className="buttons d-flex gap-3 justify-content-center">
                  <button className='btn btn-danger bg-danger btn-sm mb-0' onClick={()=>(setSelectedStatus(null))}>Cancel</button>
                  <button className='btn btn-primary btn-sm mb-0' onClick={handleChangeStatus}>Confirm</button>
              </div>
          </Modal.Body>
      </Modal>


      {/* DELETE MODAL */}
      <Modal  
          show={selectedRecord} 
          onHide={() => setSelectedRecord(null)} 
          size="sm" 
          centered
      >
          <Modal.Body className='text-center p-4'>
              <h5>Are you sure you want to delete the service category?</h5>
              <div className="buttons d-flex gap-3 justify-content-center">
                  <button className='btn btn-danger bg-danger btn-sm mb-0' onClick={()=>(setSelectedRecord(null))}>Cancel</button>
                  <button className='btn btn-primary btn-sm mb-0' onClick={handleDelete}>Confirm</button>
              </div>
          </Modal.Body>
      </Modal>
    </div>
  )
}

export default Category